import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import { MemoryRouter as Router } from 'react-router-dom';
import EmptyParams from './EmptyParams';
import RutaTematica from './RutaTematica';
import Cargando from './Cargando';
// const LayoutA = lazy(() => import('../components/Layouts/LayoutA'))
// const LayoutB = lazy(() => import('../components/Layouts/LayoutB'))
// const LayoutC = lazy(() => import('../components/Layouts/LayoutC'))
const LayoutD = lazy(() => import('../components/Layouts/LayoutD'))

const renderLayout = (lay) => {
    switch (lay) {
        // case 'A':
        //     return <LayoutA/>
        // case 'B':
        //     return <LayoutB/>
        // case 'C':
        //     return <LayoutC/>
        // case 'D':
        //     return <LayoutD/>

        default: return <LayoutD />
    }
}

const App = () => {
    const isLoading = useSelector(state => state.config.isLoading);
    const lay = useSelector(state => state.config.ui);
    const emptyParams = useSelector(state => state.error.emptyParams);
    return (
        emptyParams ? <EmptyParams /> :
            isLoading ? <Cargando /> :
                <Router>
                    <RutaTematica />
                    <Suspense fallback={<Cargando />}>
                        {renderLayout(lay)}
                    </Suspense>
                </Router>
    )

}

export default App;
